import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  fill: "none",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"50\" cy=\"50\" r=\"32\" stroke=\"#59BB1B\" stroke-width=\"2\"></circle><circle cx=\"50\" cy=\"50\" r=\"28\" fill=\"url(#a)\"></circle><path fill=\"#59BB1B\" d=\"m45.636 55.455-5.727-5.728L38 51.637l7.636 7.636L62 42.909 60.09 41z\"></path><defs><linearGradient id=\"a\" x1=\"50\" x2=\"50\" y1=\"22\" y2=\"78\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#56C91D\" stop-opacity=\".25\"></stop><stop offset=\"1\" stop-color=\"#56C91D\" stop-opacity=\"0\"></stop></linearGradient></defs>", 4)
  ])))
}
export default { render: render }